// removed by extract-text-webpack-plugin
module.exports = {"container":"_14PPBkHZMUvVoMr0Jpzz2S","icon":"_2uSpV2GszD5hiyguXAt379","menu":"_1KfBJwVaLORI5sfl-ip15q","account":"O-r_8Uibnyp9EW7-fALP1","name":"_3Y6UwvZG0i-jaMTcMBoHeC","email":"_2sUr9kQwf9GImfrB5J6aG1","menuLink":"_2rdvF661GIv3j-3_fmN6QC","signature":"kyshDUvTrXvrIip0S_RY_"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Layout/Navbar/User/styles.css
// module id = 1299
// module chunks = 0